class Zibby {
    preapprove() {
        try {
            window.zibby.preapprove();
        } catch (error) {
            console.log(error)
        }
    }
}

export default new Zibby()
